import React from 'react';

const EmptyCart = ({ cartConfig }) => {
  return (
    <div className="my-10 text-center">
      <h3 className="text-2xl font-semibold text-p-darkTeal">
        {cartConfig.empty_title}
      </h3>
      <p className="mt-2 text-sm text-p-darkTeal">
        {cartConfig.empty_secondary_text}
      </p>
      <div className="mt-5">
        <a
          className="btn inline-flex min-w-40 items-center justify-center text-base"
          href={cartConfig.empty_cta_link}
        >
          {cartConfig.empty_cta_title}
        </a>
      </div>
    </div>
  );
};

export default EmptyCart;
